<template>
  <v-tooltip max-width="177" :disabled="!tooltip" top>
    <template v-slot:activator="{ on }">
      <div
        v-on="on"
        class="label-category"
        :class="{ 'label-category--disabled': disabled }"
      >
        <img :src="require(`./img/${rideCategory.img}`)" :alt="rideCategory.text">
        <span v-if="rideCategory.text">{{ rideCategory.text }}</span>
        <strong v-if="typeof rideCategory.percentage === 'number'">
          {{ rideCategory.percentage | formatPercentage }}
        </strong>
      </div>
    </template>
    <span>{{ rideCategory.tooltip }}</span>
  </v-tooltip>
</template>

<script>
import { objectToArray } from 'corp-front-vue-commons/src/utils/functions'

export default {
  name: 'CarCategory',
  props: {
    data: {
      type: Object,
      required: true
    },
    tooltip: {
      type: Boolean,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    rideCategory () {
      const { value, percentage } = this.data
      return objectToArray(this.$t('Common.ridesCategoriesList'))
        .map(category => ({ ...category, percentage }))
        .find(category => category.value === value)
    }
  }
}
</script>

<style lang="scss" scoped>
.label-category {
  background-color: var(--gray-3);
  border: 1px solid var(--$gray-3);
  border-radius: 16px;
  color: var(--gray-7);
  display: inline-block;
  height: 32px;
  margin-bottom: 4px;
  margin-right: 8px;
  margin-top: 4px;
  padding-right: 10px;
  position: relative;

  img, span {
    display: inline-block;
    vertical-align: middle;
  }

  img {
    background-color: var(--white);
    border: 1px solid var(--gray-3);
    border-radius: 50%;
    height: 32px;
    left: -1px;
    position: relative;
    top: -1px;
    width: 32px;
  }

  span, strong {
    line-height: 1;
  }

  span {
    bottom: 1px;
    margin-left: 8px;
    position: relative;
  }

  strong {
    color: var(--gray-7) !important;
    font-family: var(--title-font);
    font-weight: 700;
    margin-left: 10px;
  }

  &.label-category--disabled {
    background-color: var(--white);
    border-color: lighten($gray-3, 1);

    img {
      border-color: lighten($gray-3, 1);
      overflow: hidden;
      position: relative;
    }

    &:before {
      border: 1px solid lighten($gray-3, 1);
      border-radius: 50%;
      background-color: rgba($white, .7);
      bottom: -1px;
      content: '';
      height: 32px;
      left: -1px;
      position: absolute;
      right: 0;
      top: -1px;
      width: 32px;
      z-index: 1;
    }
  }
}
</style>
